/* src/app/pages/accessibility-statement/accessibility-statement.page.scss */
ion-content {
  --background: #0d1117;
}
.bfsg-declaration {
  padding: 1rem;
  line-height: 1.6;
  font-size: 15px;
  color: #fff;
  --color-p-span: black;
}
.bfsg-declaration h1 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #fff;
}
.bfsg-declaration h2 {
  font-size: 18px;
  font-weight: 600;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  color: #fff;
}
.bfsg-declaration h3,
.bfsg-declaration h4 {
  color: #fff;
}
.bfsg-declaration p {
  margin-bottom: 1rem;
  color: #fff;
}
.bfsg-declaration ul {
  padding-left: 1.25rem;
  margin-bottom: 1rem;
}
.bfsg-declaration ul li {
  list-style: disc;
  margin-bottom: 0.5rem;
}
.bfsg-declaration a {
  color: #fff;
  text-decoration: underline;
}
.bfsg-declaration a:hover {
  text-decoration: none;
}
/*# sourceMappingURL=accessibility-statement.page.css.map */
